import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appDisableElement]',
})
export class DisableElementDirective {
  @Input() isDisabled!: boolean;
  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    if (this.isDisabled) {
      this.renderer.addClass(this.elementRef.nativeElement, 'disabled');
      this.elementRef.nativeElement.setAttribute('disabled', 'true');
    }
  }
}
